import SlipOpinion from './SlipOpinion';

export default SlipOpinion;
